import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom'
import ProSearchIcon from '@assets/ProSearch.svg'
import FilterModal from './FilterModal'
import { useTableStore } from '@/store/table/table'
import { useAppTheme } from '@/theme/ThemeContext'

const ProSearch = ({ onClearFilters }: { onClearFilters?: () => void }) => {
  const { clearFilteredRowsStore } = useTableStore() 

  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const location = useLocation()
  const path = location.pathname.split('?')[0]

  const isGeneral = /^\/[^/]+\/notifications\/?$/.test(path)
  const isAddntionActions = path.includes('/notifications/addntion-actions')

  const showClearButton = !(isGeneral || isAddntionActions)
  const handleClearFilters = () => {
    clearFilteredRowsStore()
    if (onClearFilters) onClearFilters()
  }
  
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'
  
  const colors = {
    bg: isDarkMode ? '#202B40' : '#FFF',
    border: isDarkMode ? '#374151' : '#E4E7EB',
    text: isDarkMode ? '#FFFFFF' : '#003F61',
    iconFilter: isDarkMode ? 'brightness(0) invert(1)' : 'none',
  }

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <Box
        sx={{
          borderRadius: '8px',
          border: `1px solid ${colors.border}`,
          background: colors.bg,
          height: '40px',
          width: '40px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={handleOpen}
      >
        <img src={ProSearchIcon} alt="ProSearch" style={{ filter: colors.iconFilter }} />
      </Box>

      {showClearButton && (
        <Box
          onClick={handleClearFilters}
          sx={{
            borderRadius: '8px',
            border: `1px solid ${colors.border}`,
            background: colors.bg,
            px: 2,
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <Typography
            sx={{
              color: colors.text,
              textAlign: 'right',
              fontFamily: 'Rubik, sans-serif',
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '100%',
            }}
          >
            ניקוי סינונים
          </Typography>
        </Box>
      )}

      <FilterModal open={open} handleClose={handleClose} />
    </Box>
  )
}

export default ProSearch
